if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
// === RUSH / 24H BLOCK (Works even if pickup fields are outside the form) ===
document.addEventListener("DOMContentLoaded", () => {
  const addBtn =
    document.querySelector('product-form button[type="submit"]') ||
    document.querySelector('form[action*="/cart/add"] button[type="submit"]');

  if (!addBtn) return;

  // Busca por TEXTO/ATRIBUTOS (global, no solo dentro del form)
  function findField(kind) {
    const selectors = [
      'input[type="date"]',
      'input[type="time"]',
      "input",
      "select",
      "textarea",
    ];

    const els = Array.from(document.querySelectorAll(selectors.join(",")));

    const keywords = ["pickup", "pick up", "recog", "recogido", "recogida"];
    const kindWords =
      kind === "date" ? ["date", "fecha"] : ["time", "hora"];

    let best = null;
    let bestScore = 0;

    for (const el of els) {
      const type = (el.getAttribute("type") || "").toLowerCase();
      const hay = [
        el.getAttribute("name"),
        el.getAttribute("id"),
        el.getAttribute("placeholder"),
        el.getAttribute("aria-label"),
        el.getAttribute("data-label"),
        el.closest("label")?.innerText,
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

      const hasKeyword = keywords.some((k) => hay.includes(k));
      const hasKindWord = kindWords.some((k) => hay.includes(k));
      const typeMatches =
        (kind === "date" && type === "date") ||
        (kind === "time" && type === "time");

      const score = (hasKeyword ? 3 : 0) + (hasKindWord ? 2 : 0) + (typeMatches ? 3 : 0);

      if (score > bestScore) {
        bestScore = score;
        best = el;
      }
    }

    // Solo devuelve si encontró algo razonable
    return bestScore >= 3 ? best : null;
  }

  function parsePickup(dateStr, timeStr) {
    if (!dateStr || !timeStr) return null;

    // date YYYY-MM-DD
    const [y, m, d] = dateStr.split("-").map(Number);
    if (!y || !m || !d) return null;

    // time puede venir "10:00 a. m." o "10:00 am"
    let t = String(timeStr).toLowerCase().trim();
    t = t.replace("a. m.", "am").replace("p. m.", "pm").replace(/\s+/g, "");

    const match = t.match(/^(\d{1,2}):(\d{2})(am|pm)?$/);
    if (!match) return null;

    let hh = Number(match[1]);
    let mm = Number(match[2]);
    const ap = match[3];

    if (ap === "pm" && hh < 12) hh += 12;
    if (ap === "am" && hh === 12) hh = 0;

    return new Date(y, m - 1, d, hh, mm, 0, 0);
  }

  function showMsg() {
    if (document.getElementById("rush-24h-warning")) return;
    const msg = document.createElement("div");
    msg.id = "rush-24h-warning";
    msg.style.marginTop = "10px";
    msg.style.fontSize = "14px";
    msg.style.lineHeight = "1.3";
    msg.innerText =
      "⏰ Este producto requiere mínimo 24 horas de anticipación. Selecciona otra fecha/hora de recogido.";
    addBtn.parentElement.appendChild(msg);
  }

  function hideMsg() {
    const msg = document.getElementById("rush-24h-warning");
    if (msg) msg.remove();
  }

  function setDisabled(disabled) {
    addBtn.disabled = disabled;
    addBtn.setAttribute("aria-disabled", disabled ? "true" : "false");
    addBtn.style.opacity = disabled ? "0.6" : "1";
  }

  function validate24h() {
    const dateEl = findField("date");
    const timeEl = findField("time");

    if (!dateEl || !timeEl) {
      // Si no logra detectar campos, NO bloquea (para no dañar ventas).
      // Si quieres que BLOQUEE SIEMPRE hasta detectar campos, dímelo y lo cambio.
      setDisabled(false);
      hideMsg();
      return true;
    }

    const pickup = parsePickup(dateEl.value, timeEl.value);
    if (!pickup) {
      setDisabled(false);
      hideMsg();
      return true;
    }

    const now = new Date();
    const min = new Date(now.getTime() + 24 * 60 * 60 * 1000);
    const ok = pickup >= min;

    if (!ok) {
      setDisabled(true);
      showMsg();
    } else {
      setDisabled(false);
      hideMsg();
    }
    return ok;
  }

  document.addEventListener("change", validate24h, true);
  document.addEventListener("input", validate24h, true);

  // Revisa al cargar
  validate24h();
});
